var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report_list"},[_c('card',{attrs:{"list":_vm.dataList}}),(_vm.dataList.length === 0)?_c('van-empty',{attrs:{"description":"暂无报告"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }